module.exports = __webpack_public_path__ + "img/jingbao1.gif";